/* eslint-disable */
import { useEffect, useState } from 'react';

type UseScriptResult = [boolean, Event | string | undefined] & {
  loaded: boolean;
  error?: Event | string;
}

/**
 * Hook to load a script
 *
 * @param src {string} source of the script
 */
export const useScript = (src: string): UseScriptResult => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState<Event | string | undefined>();

  useEffect(() => {
    // Create script tag and setup
    const element = document.createElement('script');
    element.type = 'text/javascript';
    element.src = src;
    element.onload = () => setLoaded(true);
    element.onerror = e => {
      setError(e);
      setLoaded(false);
    };

    // Add script to document body
    document.body.appendChild(element);

    return () => element.remove();
  }, [src]);

  return Object.assign([loaded, error], { loaded, error }) as UseScriptResult;
};
